import { render, staticRenderFns } from "./RelatedPostItem.vue?vue&type=template&id=59ed0403&scoped=true&"
import script from "./RelatedPostItem.vue?vue&type=script&lang=js&"
export * from "./RelatedPostItem.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPostItem.vue?vue&type=style&index=0&id=59ed0403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed0403",
  null
  
)

export default component.exports